import { bootstrap } from '@avensia/excite/client';
import { SiteLayout } from '../../../nordicnest/src/app/site-layout';
import '../component-registry';
import { setupRaygunErrorLogging } from 'webapp/raygun-browser-logging';
import { AppProviders } from '../../../nordicnest/src/app/app-providers';
import { theme } from '../theme';
import { registerChildlessProviders } from '@avensia/excite/progressive-hydration';
import { setLinkUrlDecorator } from '@avensia/excite/link';
import { linkUrlDecorator } from 'webapp/link-url-decorator';
import '../global.css';

setupRaygunErrorLogging();

setLinkUrlDecorator(linkUrlDecorator);

registerChildlessProviders(AppProviders, () => ({
  theme,
}));
bootstrap(
  <AppProviders theme={theme}>
    <SiteLayout />
  </AppProviders>,
);
